module.exports = __webpack_public_path__ + "static/img/Newimg8.33f0f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Newimg8.png
// module id = xMj3
// module chunks = 36